import React from "react";
import ConsignmentFromToDateTime from "../stolen/ConsignmentFromToDateTime";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinusSquare, faPlusSquare} from "@fortawesome/free-solid-svg-icons";
import VehicleHireStatusBadge from "./VehicleHireStatusBadge";
import VehicleHireDocketDownloadButton from "./VehicleHireDocketDownloadButton";
import DriverDefinitionList from "../common/DriverDefinitionList";
import VehicleHirePaymentMethodDefinitionList from "./VehicleHirePaymentMethodDefinitionList";
import VehicleHireDocketGallery from "./VehicleHireDocketGallery";
import VehicleHirePaymentMethodBadge from "./VehicleHirePaymentMethodBadge";
import WaypointComponent from "../common/WaypointComponent";


interface VehicleHiresTableProps {
    vehicleHires: CustomerAPIVehicleHire[]
    expandedIds: Set<number>;
    onToggleExpand: (consignmentId: number) => void;
}

const VehicleHiresTable = (props: VehicleHiresTableProps) => {

    return (
        <table className="table">
            <thead>
            <tr>
                <th scope="col">&nbsp;</th>
                <th scope="col">Date / Time</th>
                <th scope="col">Hire Reference</th>
                <th scope="col">Your Reference</th>
                <th scope="col">Vehicle Type</th>
                <th scope="col">Pay By</th>
                <th scope="col">Start Location</th>
                <th scope="col">Delivery Location</th>
                <th scope="col">Status</th>
            </tr>
            </thead>
            <tbody>

            {props.vehicleHires.length < 1 &&
                <tr>
                    <td colSpan={9}>
                        <p className="text-center">No Vehicle Hires found</p>
                    </td>
                </tr>
            }

            {props.vehicleHires.map(vehicleHire => {
                const expanded = props.expandedIds.has(vehicleHire.id);
                const startingLocation = vehicleHire.locations.find(location => location.type === "STARTING");
                const deliveryLocation = vehicleHire.locations.find(location => location.type === "DELIVERY");
                const { driver } = vehicleHire;

                return (
                    <React.Fragment key={vehicleHire.id}>
                        <tr style={{
                            borderBottomStyle: expanded ? 'hidden' : 'inherit'
                        }}>
                            <td onClick={() => props.onToggleExpand(vehicleHire.id)}>
                                <FontAwesomeIcon icon={expanded ? faMinusSquare : faPlusSquare} size="lg"/>
                            </td>
                            <td>
                                <ConsignmentFromToDateTime fromDateTime={vehicleHire.hireFrom} toDateTime={vehicleHire.hireTo}/>
                            </td>
                            <td>
                                {vehicleHire.ref}
                            </td>
                            <td>
                                {vehicleHire.customerRef}
                            </td>
                            <td>
                                {vehicleHire.allocatedVehicle?.vehicleTypeDescription
                                    ?? vehicleHire.preferredVehicleType.description}<br />
                                {vehicleHire.allocatedVehicle?.registration}
                                {/*{expanded && allocatedVehicle && allocatedVehicle.vehicleTypeDescription &&*/}
                                {/*    <div className="col-4">*/}
                                {/*        <dl>*/}
                                {/*            /!*<dt>Make</dt>*!/*/}
                                {/*            /!*<dd>{ allocatedVehicle.make || <>&mdash;</> }</dd>*!/*/}
                                {/*            /!*<dt>Model</dt>*!/*/}
                                {/*            /!*<dd>{ allocatedVehicle.model || <>&mdash;</> }</dd>*!/*/}
                                {/*            <dt>Vehicle Type</dt>*/}
                                {/*            <dd>{ allocatedVehicle.vehicleTypeDescription || <>&mdash;</> }</dd>*/}
                                {/*        </dl>*/}
                                {/*    </div>*/}
                                {/*}*/}
                            </td>
                            <td>
                                <p><VehicleHirePaymentMethodBadge vehicleHire={vehicleHire} /></p>
                            </td>
                            <td>
                                {startingLocation && <WaypointComponent waypoint={startingLocation} detailed={expanded} />}
                            </td>
                            <td>
                                {deliveryLocation && <WaypointComponent waypoint={deliveryLocation} detailed={expanded} />}
                            </td>
                            <td>
                                <p><VehicleHireStatusBadge vehicleHire={vehicleHire} /></p>
                            </td>
                        </tr>
                        {expanded &&
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={8}>
                                <div className="row">

                                    {driver &&
                                        <div className="col-4">
                                            <DriverDefinitionList driver={driver} />
                                        </div>
                                    }

                                    <div className="col-4">
                                        <VehicleHirePaymentMethodDefinitionList vehicleHire={vehicleHire} />
                                    </div>

                                    <div className="col-12">
                                        <VehicleHireDocketGallery vehicleHire={vehicleHire} hidden={!expanded} />
                                        <VehicleHireDocketDownloadButton vehicleHire={vehicleHire} />
                                    </div>

                                </div>
                            </td>
                        </tr>
                        }
                    </React.Fragment>
                )
            })}

            </tbody>
        </table>
    )

}

export default VehicleHiresTable;
